import type { Theme } from '@fluentui/react-components';
import { tokens as fluentTokens } from '@fluentui/react-components';

import type { CoreUIExtendedThemeColorTokenName, OverridableCoreUIExtendedThemeTokenName } from './coreUITokens.types';
import type { CoreUITokensObject } from './tokens.types';

type FluentTokensObject = {
  [P in keyof Theme]: `var(--${P})`;
};

export const tokens = fluentTokens as FluentTokensObject;

type AllColorTokenKeys = Extract<keyof Theme, `color${string}`>;

type CoreUIColorTokenKeys = CoreUIExtendedThemeColorTokenName | OverridableCoreUIExtendedThemeTokenName;
type CoreUIColorTokensObject = CoreUITokensObject<'extendedThemeToken', CoreUIColorTokenKeys>;

export type ColorToken = FluentTokensObject[AllColorTokenKeys] | CoreUIColorTokensObject[CoreUIColorTokenKeys];
export type FUI9ColorToken = FluentTokensObject[AllColorTokenKeys];
